import { getField, updateField } from 'vuex-map-fields'

const getDefaultState = () => ({
  slide: 0
})

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    updateField
  },
  getters: {
    getField
  }
}
